import vesselFields from './fields';
import Joi from 'joi';

const cg719sFields = {
    ...vesselFields,
    tonnage: {
        ...vesselFields.tonnage,
        validation: Joi.when('width_tonnage', {
            is: Joi.number(),
            then: Joi.when('depth_tonnage', {
                is: Joi.number(),
                then: Joi.number()
                    .max(199)
                    .positive()
                    .allow(null, '')
                    .messages({
                        'number.max':
                            'This form, the CG-719S, can only be used for vessels less than 200 GRT',
                    }),
                otherwise: Joi.number().max(199).positive().messages({
                    'number.max':
                        'This form, the CG-719S, can only be used for vessels less than 200 GRT',
                    'number.base':
                        'This or length, width, and draft are required',
                }),
            }),
            otherwise: Joi.number().max(199).positive().messages({
                'number.max':
                    'This form, the CG-719S, can only be used for vessels less than 200 GRT',
                'number.base': 'This or length, width, and draft are required',
            }),
        }),
    },
};

export default cg719sFields;
